import {QUESTION_VISUAL_ORIENTATION} from "../../scripts/myga-model";
import QuestionText from "./QuestionText";
import {Col, Container, Row} from "react-bootstrap";
import SubQuestions from "./SubQuestions";
import React, {useMemo} from "react";
import {
  PROCESS_CHILDREN_LAYOUT,
  PROCESS_QUESTION_PLACEMENT_QUESTION,
  PROCESS_QUESTION_PLACEMENT_RESPONSE,
  PROCESS_QUESTION_CONTAINER_CLASSNAME,
  PROCESS_VISUAL_ORIENTATION
} from "../../scripts/layout-manager";
import useWindowWidthResize from "../../scripts/UseWindowWidthResize";
import {NassauLog} from "../../scripts/myga-utils";
import QuestionFootnote from "./QuestionFootnote";

export default function QuestionLayout(props) {
  const {question, questionClass='', textClass='', childrenClass='', handleChange, data} = props;
  let {containerClass=''} = props;

  const orientation = useWindowWidthResize(() => PROCESS_VISUAL_ORIENTATION(question));
  const questions = useMemo(() => question.questions || [], [question]);
  const justifyChildren = `${PROCESS_CHILDREN_LAYOUT(question)}`

  const renderSubQuestions = subQuestions =>  (
    <Row>
      <SubQuestions questions={subQuestions}
                    handleChange={handleChange}
                    data={data}
      />
    </Row>
  )
  
  const renderQuestionText = useMemo(() => {
    let containerClassname = PROCESS_QUESTION_CONTAINER_CLASSNAME(question)
    if (orientation === QUESTION_VISUAL_ORIENTATION.vertical) {
      return (
        <Row className={containerClassname}>
          <QuestionText question={question}
                        questionClass={questionClass}
                        textClass={textClass}/>
        </Row>
      )
    }
    return <QuestionText question={question}
                         questionClass={`${containerClassname} ${questionClass}`}
                         textClass={textClass}/>
  }, [textClass, orientation, question, questionClass])

  return (
    <Container className={containerClass}>
      {
        orientation === QUESTION_VISUAL_ORIENTATION.horizontal && (
          <Row>
            {renderQuestionText}
            <Col className={`${childrenClass} ${justifyChildren} pl-0 pr-0 d-flex flex-wrap`}>
              {props.children}
              {renderSubQuestions(PROCESS_QUESTION_PLACEMENT_RESPONSE(questions))}
            </Col>
          </Row>
        )
      }

      {
        orientation === QUESTION_VISUAL_ORIENTATION.vertical && (
          <>
            {renderQuestionText}
            <Row>
              <Col className={`${childrenClass} ${justifyChildren} pl-0 pr-0 d-flex flex-wrap`}>
                {props.children}
                {renderSubQuestions(PROCESS_QUESTION_PLACEMENT_RESPONSE(questions))}
              </Col>
            </Row>
          </>
        )
      }
      {(question.footnote?.text && !question.footnote?.placement) && (
        <QuestionFootnote question={question}/>
      )}
      {renderSubQuestions(PROCESS_QUESTION_PLACEMENT_QUESTION(questions))}
    </Container>
  )
}